export const hamletEndpoints = {
    tag: {
        list: {
            api: '/api/hamlet/tag/list',
            method: 'GET',
            parameter: false
        },
        dictionary: {
            api: '/api/hamlet/tag/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    article: {
        list: {
            api: '/api/hamlet/support-article/list',
            method: 'GET',
            parameter: false
        },
        listPerSection: {
            api: '/api/hamlet/support-article/list-per-section',
            method: 'GET',
            parameter: true
        },
        listPerFilter: {
            api: '/api/hamlet/support-article/list-per-filter',
            method: 'GET',
            parameter: true
        },
        listPerTag: {
            api: '/api/hamlet/support-article/list-per-tag',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/hamlet/support-article/details',
            method: 'GET',
            parameter: true
        },
        detailsBySearchKey: {
            api: '/api/hamlet/support-article/details/search-key',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/hamlet/support-article/add',
            method: 'POST',
            parameter: false
        },
        rate: {
            api: '/api/hamlet/support-article/rate',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/hamlet/support-article/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/hamlet/support-article/delete',
            method: 'POST',
            parameter: false
        }
    },
    section: {
        tree: {
            api: '/api/hamlet/support-section',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/hamlet/support-section/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/hamlet/support-section/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/hamlet/support-section/delete',
            method: 'POST',
            parameter: false
        },
        reorder: {
            api: '/api/hamlet/support-section/reorder',
            method: 'POST',
            parameter: false
        },
        whatsNewSection: {
            api: '/api/hamlet/support-article/list-whats-new',
            method: 'GET',
            parameter: false
        }
    },
    configuration: {
        list: {
            api: '/api/hamlet/configuration',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/hamlet/configuration/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/hamlet/configuration/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/hamlet/configuration/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/hamlet/configuration/delete',
            method: 'POST',
            parameter: false
        }
    },
    dictionary: {
        articleStatus: {
            api: '/api/hamlet/configuration/dictionary/article-status',
            method: 'GET',
            parameter: false
        },
        articleVisibility: {
            api: '/api/hamlet/configuration/dictionary/article-visibility',
            method: 'GET',
            parameter: false
        },
        articleAccountTypes:{
            api: '/api/hamlet/configuration/dictionary/article-account-type',
            method: 'GET',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/hamlet.endpoints.ts